/**
 * Search
 */

export default function Search() {
    const selectors = {
        'searchBox' : '.js-search-form',
    };

    this.init = () => {
        jQuery(function ($) {
            "use strict";
            $(document).on('submit', selectors.searchBox, (e) => {
                e.preventDefault();
                let $form = jQuery(e.target);
                let action = $form.attr('action');
                let search =  encodeURIComponent($form.find('input[name="s"]').val()).replace(/%20/g, "+")

                let url = `${action}${search}/`
                location.href = url;
                return false;
            })
        });
    };
}
